import React, { CSSProperties } from "react";
import { DirectionalHint, TooltipHost } from "@fluentui/react";
import { useTruncatedText } from "./TruncatedTextHook";

export interface TruncatedTextProps {
  text: string;
  style?: CSSProperties;
  tooltipDirectionalHint?: DirectionalHint;
  renderer?: (text: string, ref: React.RefObject<HTMLSpanElement>) => React.ReactElement;
}

export function TruncatedText({
  text,
  style,
  tooltipDirectionalHint = DirectionalHint.topCenter,
  renderer,
}: Readonly<TruncatedTextProps>): React.ReactElement {
  const { textRef, isTruncated } = useTruncatedText(text);

  const defaultTextStyle: CSSProperties = {
    fontWeight: "bold",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
    ...style,
  };

  // Rendering del contenuto usando il renderer personalizzato o quello di default
  const renderContent = (): React.ReactElement => {
    if (renderer) {
      return renderer(text, textRef);
    }
    return (
      <span ref={textRef} style={defaultTextStyle}>
        {text}
      </span>
    );
  };

  if (isTruncated) {
    return (
      <TooltipHost
        content={text}
        directionalHint={tooltipDirectionalHint}
        styles={{ root: { minWidth: 0, overflow: "hidden" } }}
      >
        {renderContent()}
      </TooltipHost>
    );
  }

  return renderContent();
}
